"use client";

import { useSelector } from "react-redux";
import { useContext, useEffect } from "react";

import dynamic from "next/dynamic";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import { useStoreContext } from "@components/store/provider";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";
import ProductDetailProvider from "@contexts/product-detail-context";
import StoreProductContainer from "@components/store/products/listing/details";
import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";

const KitItemsProvider = dynamic(() => import("@contexts/kit-items"));
const KitProductContainer = dynamic(() => import("@components/store/products/kit-listing/details"));
const KitLayout = dynamic(() => import("@components/layout/kit"));

import { getCountry } from "@selectors/country";

import { getStoreBasePath, getMenuRoute } from "@constants/routes";
import { getStore } from "@selectors/store";

const DEFAULT_OBJ = {};

const StoreProductDetail = ({ storeNumber, productData, cmsSectionIndex }) => {
  const store = useSelector(getStore);
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const { countryCode, lang, storeCode, isNewRoute, workspaceSlug } = useStoreContext();

  const country = useSelector(getCountry);

  const router = useRouter();
  const { productSlug } = router.query;

  const { isKitShop } = store || DEFAULT_OBJ;

  useEffect(() => {
    if (country?.iso && country?.iso?.toLowerCase() !== countryCode.toLowerCase() && isKitShop) {
      const storeBasePath = getStoreBasePath({
        countryCode,
        lang,
        storeCode,
        storeNumber,
        isNewRoute,
        workspaceSlug,
      });

      router.push(getMenuRoute({ storeBasePath }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, store, country?.iso, isKitShop, workspaceSlug]);

  return (
    <ProductDetailProvider>
      <BottomIconHideWrapper hideIcon={isMobileDevice}>
        {isKitShop ? (
          <KitItemsProvider>
            <KitLayout>
              <KitProductContainer productSlug={productSlug} productData={productData} />
            </KitLayout>
          </KitItemsProvider>
        ) : (
          <StoreProductContainer
            productSlug={productSlug}
            productData={productData}
            cmsSectionIndex={cmsSectionIndex}
          />
        )}
      </BottomIconHideWrapper>
    </ProductDetailProvider>
  );
};
export default StoreProductDetail;
